module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('pkHeader', {
    attrs: {
      "headerTitle": _vm.title,
      "rightContentProps": false,
      "rightPhoneProps": true,
      "serverphone": _vm.serverphone
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.defaul),
      expression: "defaul"
    }],
    staticClass: "contente"
  }, [_c('div', {
    staticClass: "order"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.dirverInfo.length !== 0) ? _c('div', {
    staticClass: "driverInfo",
    staticStyle: {
      "background": "#fff",
      "height": "100%",
      "padding-top": ".5rem"
    }
  }, [_c('div', {
    staticClass: "weui_cell"
  }, [_c('div', {
    staticClass: "driver_photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.dirverInfo.headPic ? _vm.dirverInfo.headPic : ('./static/img/img_default@2x.png')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "driver_info"
  }, [_c('p', [_vm._v(_vm._s(_vm.dirverInfo.name) + " " + _vm._s(_vm.dirverInfo.carNo))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dirverInfo.carType))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "call_phone",
    class: {
      'call_phoneisup': !_vm.isCall
    },
    on: {
      "click": _vm.calldrive
    }
  })]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.dirverInfo.length === 0 && _vm.orderInfo.orderState == 'success') ? _c('div', {
    staticClass: "weui_cells mt0"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _c('group', {
    staticClass: "order_cont "
  }, [_c('div', {
    staticClass: "weui-cell vux-cell-form-preview vux-cell-no-border-intent "
  }, [_c('div', {
    staticClass: "item-title label custom detail-title"
  }, [_c('p', {
    staticStyle: {
      "padding-bottom": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.upAddress))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.orderInfo.downAddress))])]), _vm._v(" "), (_vm.orderInfo.orderState == 'compile') ? _c('div', {
    staticClass: "wei-right"
  }, [_c('div', [_c('font', {
    attrs: {
      "size": "5",
      "color": "#393939"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.tradePrice))]), _vm._v(" 元")], 1)]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderState == 'success' && _vm.isup) ? _c('div', {
    staticClass: "wei-right"
  }, [_c('div', {
    staticClass: "circle"
  }, [_vm._v("已上车")])]) : _vm._e()])]), _vm._v(" "), (_vm.orderInfo.orderState != 'compile') ? _c('div', {
    staticClass: "weui_cells"
  }, [_c('div', {
    staticClass: "weui_cell"
  }, [_c('div', {
    staticClass: "data_time"
  }, [_vm._v(_vm._s(_vm.orderInfo.bookDate) + " " + _vm._s(_vm.orderInfo.dirverTime))]), _vm._v(" "), _c('div', {
    staticClass: "pepole_nu"
  }, [_vm._v(_vm._s(_vm.orderInfo.number) + "人")]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "weui_cell wexx"
  }, [_c('div', {
    staticClass: "phoneN data_time"
  }, [_vm._v(_vm._s(_vm.orderInfo.contactMobile))]), _vm._v(" "), (_vm.dirverInfo.length != 0 || _vm.orderInfo.orderState != 'success') ? _c('div', {
    staticClass: "icon_price"
  }, [_c('i', {
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.tradePrice))]), _vm._v("元\n\n                            "), _c('badge', {
    class: _vm.orderInfo.discountName ? 'top-bar top-bar-jz' : 'top-bar top-bar-sz',
    staticStyle: {
      "position": "absolute",
      "right": "1%",
      "top": "0"
    },
    attrs: {
      "text": _vm.orderInfo.discountName ? _vm.orderInfo.discountName : '专车接驾'
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.dirverInfo.length == 0 && _vm.orderInfo.orderState == 'success') ? _c('group', {
    staticStyle: {
      "border-top": "0",
      "margin-top": "10px"
    },
    attrs: {
      "label-width": "4.5em",
      "label-margin-right": "2em",
      "label-align": "right",
      "gutter": "0"
    }
  }, [_c('div', {
    staticClass: "price-bar"
  }, [_c('div', {
    staticClass: "price-content"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.8rem",
      "margin-right": ".2rem"
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.tradePrice))]), _vm._v("元\n                            "), _c('badge', {
    class: _vm.orderInfo.discountName ? 'top-bar top-bar-jz' : 'top-bar top-bar-sz',
    attrs: {
      "text": _vm.orderInfo.discountName ? _vm.orderInfo.discountName : '专车接驾'
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderState == 'compile') ? _c('div', {
    staticStyle: {
      "background": "rgb(255, 255, 255)",
      "margin-top": "-1rem",
      "padding-bottom": "1rem"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(4), _vm._v(" "), _c('rater', {
    staticStyle: {
      "margin": "1rem 0"
    },
    attrs: {
      "star": "  ",
      "margin": 15,
      "disabled": !_vm.isComment
    },
    model: {
      value: (_vm.roate),
      callback: function($$v) {
        _vm.roate = $$v
      },
      expression: "roate"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#3a3a3a",
      "padding-top": "1rem"
    }
  }, [_vm._v("您的评价将有助于提高用户叫车规范")])], 1), _vm._v(" "), _c('div', {}, [(_vm.show_labels) ? _c('div', {
    staticClass: "weui_cell"
  }, [_c('div', {
    staticClass: "weui_cell_bd weui_cell_primary"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isComment && _vm.labels),
      expression: "!isComment&&labels"
    }]
  }, [_vm._v("您选择的标签")]), _vm._v(" "), _c('div', {
    staticClass: "labels"
  }, [_vm._l((_vm.labels[_vm.roate - 1]), function(label, index) {
    return (_vm.isComment) ? [_c('span', {
      on: {
        "click": function($event) {
          _vm.changeActive(index)
        }
      }
    }, [_vm._v(_vm._s(label))])] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.labels), function(label, index) {
    return (!_vm.isComment) ? [_c('span', {
      staticClass: "active"
    }, [_vm._v(_vm._s(label))])] : _vm._e()
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.show_textarea) ? _c('div', {
    staticClass: "weui_cell wexx"
  }, [_c('div', {
    staticClass: "weui_cell_bd weui_cell_primary",
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.isComment) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Opinion),
      expression: "Opinion"
    }],
    staticClass: "weui_textarea",
    attrs: {
      "placeholder": "其他想说的",
      "rows": "3",
      "maxlength": "180",
      "spellcheck": "false",
      "cols": "30"
    },
    domProps: {
      "value": (_vm.Opinion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Opinion = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isComment) ? _c('div', {
    staticClass: "weui_textarea_counter"
  }, [_vm._v("还可输入"), _c('span', {
    staticStyle: {
      "color": "#3E3E3E"
    }
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v("个字符\n                                ")]) : _vm._e(), _vm._v(" "), (!_vm.isComment) ? _c('div', [_vm._v("\n                                    您的意见与建议：\n                                    "), _c('div', {
    staticStyle: {
      "color": "#BEBEBE"
    }
  }, [_vm._v(_vm._s(_vm.Opinion))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.isComment) ? _c('div', {
    staticStyle: {
      "overflow": "hidden",
      "margin": "15px"
    }
  }, [_c('x-button', {
    staticStyle: {
      "background": "#0d87e4",
      "font-size": ".85rem",
      "padding": "4px 0"
    },
    attrs: {
      "type": "primary",
      "action-type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.comment($event)
      }
    }
  }, [_vm._v("\n                                提交\n                            ")])], 1) : _vm._e()])]) : _vm._e()], 1)]), _vm._v(" "), (_vm.orderInfo.orderState == 'success' && !_vm.isup) ? _c('div', {
    staticStyle: {
      "overflow": "hidden",
      "margin": "10px"
    }
  }, [_c('x-button', {
    staticStyle: {
      "background": "#0d87e4",
      "font-size": ".85rem",
      "padding": "4px 0"
    },
    attrs: {
      "type": "primary",
      "action-type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showdialog($event)
      }
    }
  }, [_vm._v("\n                取消行程 (退款)\n\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.orderInfo.orderState != 'success' && _vm.orderInfo.orderState != 'compile') ? _c('div', {
    staticClass: "state_jd"
  }, [_c('p', {
    staticClass: "state_n"
  }, [_vm._v("\n            " + _vm._s(_vm.orderInfo.orderState == 'refuse' && '已拒单' || _vm.orderInfo.orderState == 'refunded' && '已关闭' || _vm.orderInfo.orderState == 'clear' && '已取消' || _vm.orderInfo.orderState == 'pending' && '待支付' || _vm.orderInfo.orderState == 'expiration' && '已关闭') + " ")]), _vm._v(" "), _c('p', [_vm._v("请选择其他方式出行")]), _vm._v(" "), _c('p', {
    staticClass: "state_sm"
  }, [_vm._v("款项将于7个工作日内退回原支付账户")])]) : _vm._e()]), _vm._v(" "), _c('x-dialog', {
    staticClass: "dialog-demo1",
    model: {
      value: (_vm.shows),
      callback: function($$v) {
        _vm.shows = $$v
      },
      expression: "shows"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "font-size": "1rem"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": ".5rem",
      "text-align": "center",
      "border-bottom": ".333px solid #D5D5D6"
    }
  }, [_vm._v("取消行程")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": ".5rem 1rem"
    }
  }, [_c('div', {
    staticClass: "dialog-demo-info"
  }, [_c('span', [_vm._v("人数")]), _c('span', [_vm._v(_vm._s(_vm.orderInfo.number) + "人")]), _vm._v(" "), _c('span', [_vm._v("类型")]), _c('span', [_vm._v("不拼车")]), _vm._v(" "), _c('span', [_vm._v("实付")]), _c('span', [_vm._v("¥" + _vm._s(_vm.orderInfo.tradePrice))]), _vm._v(" "), _c('span', [_vm._v("退款")]), _c('span', [_vm._v("¥" + _vm._s(_vm.refundPrice))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": ".5rem",
      "font-size": ".9rem"
    }
  }, [_vm._v("点击“确认退票”后，退款金额预计在7个工作日内原路退回你的账户中，请注意查收。如有问题，请拨打客服电话 "), _c('i', {
    staticStyle: {
      "color": "#0d87e4",
      "display": "block"
    }
  }, [_vm._v(_vm._s(_vm.serverphone))])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_default",
    staticStyle: {
      "color": "#0d87e4",
      "font-size": "1rem"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.shows = false
      }
    }
  }, [_vm._v("我再想想")]), _vm._v(" "), _c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    staticStyle: {
      "color": "#0d87e4",
      "font-size": "1rem"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.cancalv
    }
  }, [_vm._v("确认退票")])])])]), _vm._v(" "), _c('x-dialog', {
    staticClass: "dialog-demo1",
    model: {
      value: (_vm.shows_phone),
      callback: function($$v) {
        _vm.shows_phone = $$v
      },
      expression: "shows_phone"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "font-size": ".9rem",
      "padding": "1rem"
    }
  }, [_vm._v("\n            为了保障您和乘客的隐私，行程结束1小时后若需要联系对方请告知客服转达。\n        ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "weui-dialog__ft"
  }, [_c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_default",
    staticStyle: {
      "color": "#0d87e4",
      "font-size": "1rem"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.calldriver(1)
      }
    }
  }, [_vm._v("联系客服")]), _vm._v(" "), _c('a', {
    staticClass: "weui-dialog__btn weui-dialog__btn_primary",
    staticStyle: {
      "color": "#0d87e4",
      "font-size": "1rem"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.shows_phone = false
      }
    }
  }, [_vm._v("取消")])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "margin-top": ".5rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "3rem",
      "margin-right": "1rem",
      "display": "none"
    },
    attrs: {
      "src": require("../../assets/img/ico_posi.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "state_p"
  }, [_c('span', [_vm._v("已支付")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "state_pc"
  }, [_c('p', {
    staticClass: "state_d"
  }, [_vm._v("等待派车")]), _vm._v(" "), _c('p', {
    staticClass: "state_p"
  }, [_c('span', [_vm._v("已支付")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jbtype wyouhui"
  }, [_c('i', [_vm._v("不")]), _vm._v("拼车")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "state_p"
  }, [_c('span', {
    staticClass: "c9b",
    staticStyle: {
      "color": "#595959",
      "width": "7rem",
      "margin-left": "-3.5rem"
    }
  }, [_vm._v("匿名评价司机")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbe92cda"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/orderDetail.vue
// module id = 427
// module chunks = 1